export default {
	ListPages: (state) => {
		return state.allPages.map(page => {
			return {
				key: page.key,
				total: page.questions.length
			}
		})
	},
	totalPages: (state, getters) => {
		if(getters.ListPages.length > 0) {
			return getters.ListPages.map(page => page.total).reduce((a, b) =>a + b);
		}
		return 0;
	},
	thereAreQuestions: (state, getters) => {
		const total = getters.ListPages.map(page => page.total).reduce((a, b) => a + b, 0);
		if(total > 0) return true;
		return false;
	},
	getAllQuestions: (state, getters) => {
		return state.allPages.map(a => a.questions).reduce((a, b) => [...a, ...b], []);
	},
    isSubFormualrio: (state) => state.dataSidebar.isSubForm
}
